import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/youngs-modulus-calculator',
  component: () => import('../../routes/YoungModulusCalculator.svelte'),
  card: {
    id: 'youngs-modulus-calculator',
    title: 'Young\u2019s Modulus Calculator',
    description:
      'Solve stress, strain, Young\u2019s modulus, and axial elongation from Hooke\u2019s law (σ = E·ε). Includes 16 material presets (steel, aluminum, copper, brass, titanium, glass, wood, rubber) and full unit support (Pa/psi/MPa/GPa, N/lbf, m/mm/in/ft).',
    icon: 'compress',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/youngs-modulus-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Young\u2019s Modulus Calculator \u2013 Stress, Strain & Elongation (σ = E\u00b7ε)',
    description:
      'Free Young\u2019s modulus calculator using Hooke\u2019s law. Solve for elastic modulus, stress, strain, or axial elongation. Supports Pa/psi/MPa/GPa, N/lbf, m/mm/in/ft. Includes material presets for steel, aluminum, copper, brass, titanium, glass, wood, concrete, rubber, and more.',
  },
};

export default meta;